import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const LVPLowVisibilityIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M13.0526 4C15.4935 4 17.5032 5.7539 17.7614 8.00747C19.6065 8.11316 21.1539 9.33049 21.7439 11H2.10529C2.59294 8.71776 4.71689 7 7.26316 7C7.70125 7 8.12684 7.05085 8.53375 7.14668C9.13843 5.32269 10.9329 4 13.0526 4Z'
                fill='currentColor'
            />
            <Path d='M10.9755 18.5923H2V20.2235H11L10.9755 18.5923Z' fill='currentColor' />
            <Path d='M14 18.5923H21.9755L22 20.2235H14V18.5923Z' fill='currentColor' />
            <Path
                d='M5.5532 15.6411L2 15.6401V17.2714H5.55224L5.5532 15.6411Z'
                fill='currentColor'
            />
            <Path
                d='M7.99998 15.6401L22.0009 15.6411L22 17.2714L7.99998 17.2714V15.6401Z'
                fill='currentColor'
            />
            <Path d='M2.02448 14.3202H13.16V12.6889L2.02448 12.688V14.3202Z' fill='currentColor' />
            <Path d='M22 14.3202H15V12.688L22 12.6889V14.3202Z' fill='currentColor' />
        </>
    ),
})

LVPLowVisibilityIcon.displayName = 'LVPLowVisibilityIcon'
